/* eslint-disable no-unused-vars */
import React, { memo, useContext } from 'react';
import './css/HomePage1.css';
import HomePage1Section1 from './homePage1Section1/HomePage1Section1';
import HomePage1Section2 from './homePage1Section2/HomePage1Section2';
import HomePage1Section3 from './homePage1Section3/HomePage1Section3';
import HomePage1Section4 from './homePage1Section4/HomePage1Section4';
import HomePage1Section5 from './homePage1Section5/HomePage1Section5';
import HomePage1Section6 from './homePage1Section6/HomePage1Section6';
import HomePage1Section7 from './homePage1Section7/HomePage1Section7';
import HomePage1Section9 from './homepage1Section9/HomePage1Section9';
import HomePage1Section10 from './homePage1Section10/HomePage1Section10';
import HomePage1Section11 from './homePage1Section11/HomePage1Section11';
import HomePage1Section12 from './homePage1Section12/HomePage1Section12';
import HomePage1Section13 from './homePage1Section13/HomePage1Section13';
import HomePage1Section14 from './homePage1Section14/HomePage1Section14';
import HomePage1Section16 from './homePage1Section16/HomePage1Section16';
import HomePage1Section15 from './homePage1Section15/HomePage1Section15';
import HomePage1Section17 from './homePage1Section17/HomePage1Section17';
import HomePage1Section18 from './homePage1Section18/HomePage1Section18';
import HomePage1Section19 from './homePage1Section19/HomePage1Section19';
import { context } from '../../../globalState/GlobalState';
import { WebsiteDesignType } from '../../../catalog/enums/WebsiteDesignType';
import HomePage1Section20 from './homePage1Section20/HomePage1Section20';
import HomePage1Section21 from './homePage1Section21/HomePage1Section21';
import HomePage1Section23 from './homePage1Section23/HomePage1Section23';
import AdComponent1 from '../../uiElements/adComponents/adComponent1/AdComponent1';

const HomePage1 = () => {
    const { globalState } = useContext(context);

    const getFirstSection = () => {
        if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_1) {
            return (
                <>
                    <HomePage1Section11 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_2) {
            return (
                <>
                    <HomePage1Section11 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_3) {
            return (
                <>
                    <HomePage1Section1 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_4) {
            return (
                <>
                    <HomePage1Section12 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_5) {
            return (
                <>
                    <HomePage1Section11 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_6) {
            return (
                <>
                    <HomePage1Section23 showMobile={false} />
                    <HomePage1Section11 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_7) {
            return (
                <>
                    <HomePage1Section11 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_8) {
            return (
                <>
                    <HomePage1Section11 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_9) {
            return (
                <>
                    <HomePage1Section21 showMobile={false} smaller />
                    <HomePage1Section11 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_10) {
            return (
                <>
                    <HomePage1Section11 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_11) {
            return (
                <>
                    <HomePage1Section18 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_12) {
            return (
                <>
                    <HomePage1Section21 showMobile={false} smaller />
                    <HomePage1Section18 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_13) {
            return (
                <>
                    <HomePage1Section18 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_14) {
            return (
                <>
                    <HomePage1Section18 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_15) {
            return (
                <>
                    <HomePage1Section23 showMobile={false} />
                    <HomePage1Section18 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_16) {
            return (
                <>
                    <HomePage1Section18 />
                </>
            );
        }
        return (
            <>
                <HomePage1Section11 />
            </>
        );
    };

    const getSecondSection = () => {
        if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_1) {
            return (
                <>
                    <HomePage1Section2 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_2) {
            return (
                <>
                    <HomePage1Section13 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_3) {
            return (
                <>
                    <HomePage1Section2 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_4) {
            return (
                <>
                    <HomePage1Section14 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_5) {
            return (
                <>
                    <HomePage1Section23 />
                    <HomePage1Section20 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_6) {
            return (
                <>
                    <HomePage1Section19 showDesktop={false} showMobile smaller />
                    <HomePage1Section20 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_7) {
            return (
                <>
                    <HomePage1Section23 secondaryBackgroundColor />
                    <HomePage1Section20 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_8) {
            return (
                <>
                    <HomePage1Section21 />
                    <HomePage1Section20 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_9) {
            return (
                <>
                    <HomePage1Section19 showDesktop={false} showMobile smaller />
                    <HomePage1Section20 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_10) {
            return (
                <>
                    <HomePage1Section21 primaryBackgroundColor />
                    <HomePage1Section20 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_11) {
            return (
                <>
                    <HomePage1Section21 />
                    <HomePage1Section20 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_12) {
            return (
                <>
                    <HomePage1Section19 showDesktop={false} showMobile smaller />
                    <HomePage1Section20 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_13) {
            return (
                <>
                    <HomePage1Section21 primaryBackgroundColor />
                    <HomePage1Section20 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_14) {
            return (
                <>
                    <HomePage1Section23 />
                    <HomePage1Section20 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_15) {
            return (
                <>
                    <HomePage1Section19 showDesktop={false} showMobile smaller />
                    <HomePage1Section20 />
                </>
            );
        } if (globalState.websiteStyles.design.homepage === WebsiteDesignType.DESIGN_16) {
            return (
                <>
                    <HomePage1Section23 secondaryBackgroundColor />
                    <HomePage1Section20 />
                </>
            );
        }
        return (
            <>
                <HomePage1Section2 />
            </>
        );
    };

    return (
        <div className="homepage1-container x-center">
            {getFirstSection()}
            {getSecondSection()}
            {/* <HomePage1Section17 /> */}
            <HomePage1Section15 />
            <AdComponent1
                showDesktop
                showMobile
                desktopContainerId="ads-container-above-socials"
                mobileContainerId="ads-container-above-socials"
                placementId="homepage-above-socials"
            />
            <HomePage1Section3 />
            <HomePage1Section16 />
            <HomePage1Section4 />
            <HomePage1Section5 />
            <HomePage1Section6 />
            <HomePage1Section7 />
        </div>
    );
};

export default memo(HomePage1);
